var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "product-offer-table-row",
    class: _vm.publicationStatusClass
  }, [_c('td', [_c('span', {
    attrs: {
      "title": _vm.publicationStatusDescription
    }
  }, [_vm._v(_vm._s(_vm.publicationStatusIcon))])]), _vm._v(" "), _c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'offer',
        params: {
          id: _vm.offer.id
        }
      }
    }
  }, [(_vm.offer.contract) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.$t('labels.withContract', {
    name: _vm.offer.contract.name
  })) + "\n      ")]) : _c('span', [_vm._v(_vm._s(_vm.$t('labels.noContract')))])])], 1), _vm._v(" "), _c('td', [(_vm.onetimeDefaultPrice) ? [_c('price', {
    attrs: {
      "value": _vm.onetimeDefaultPrice
    }
  }), _vm._v(" "), (_vm.onetimeWasPrice) ? _c('span', [_vm._v("\n        (statt "), _c('price', {
    attrs: {
      "was": "",
      "value": _vm.onetimeWasPrice
    }
  }), _vm._v(")\n      ")], 1) : _vm._e()] : _c('text-placeholder')], 2), _vm._v(" "), _c('td', [(_vm.monthlyDefaultPrice) ? [_c('price', {
    attrs: {
      "value": _vm.monthlyDefaultPrice
    }
  }), _vm._v(" "), (_vm.monthlyWasPrice) ? _c('span', [_vm._v("\n        (statt "), _c('price', {
    attrs: {
      "was": "",
      "value": _vm.monthlyWasPrice
    }
  }), _vm._v(")\n      ")], 1) : _vm._e()] : _c('text-placeholder')], 2), _vm._v(" "), _c('td', [_c('separated-list', {
    attrs: {
      "items": _vm.tenantNames
    }
  })], 1), _vm._v(" "), _c('td', [_c('data-grid-actions', {
    attrs: {
      "edit-route": {
        name: 'edit-offer',
        params: {
          id: _vm.offer.id
        }
      },
      "removable": false
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d9de3f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductOfferTableRow.vue
// module id = 1849
// module chunks = 0